import { styled } from "@mui/material/styles";
import { Paper } from "@mui/material";

export const StyledBackButtonBox = {
  mb: 2,
} as const;

export const StyledMetadataPaper = styled(Paper)(() => ({
  borderRadius: 8,
  overflow: "hidden",
  marginBottom: 16,
}));

export const StyledMetadataHeader = {
  px: 2,
  py: 1.5,
  borderBottom: "1px solid",
  borderColor: "divider",
} as const;

export const StyledMetadataContent = {
  px: 2,
  py: 1.5,
  // Reduce typography sizes inside metadata for compactness
  '& .MuiTypography-body2': {
    fontSize: '0.82rem',
    lineHeight: 1.2,
  },
} as const;

export const StyledLogo = {
  width: 32,
  height: 32,
  borderRadius: 2,
  objectFit: "cover",
  display: "inline-block",
  mr: 1,
} as const;

export const StyledStatsGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
  gap: 1,
  mb: 2,
} as const;

export const StyledChunksPaper = styled(Paper)(() => ({
  borderRadius: 8,
  maxHeight: 460,
  overflow: "hidden",
}));

export const StyledChunkHeader = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  px: 2,
  py: 1.25,
  borderBottom: "1px solid",
  borderColor: "divider",
} as const;

export const StyledChunkItem = {
  px: 2,
  py: 1,
  borderBottom: "1px solid",
  borderColor: "divider",
  cursor: "pointer",
  transition: "background-color 0.2s ease",
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.04)",
  },
  "&:last-child": {
    borderBottom: "none",
  },
} as const;

export const StyledChunksContainer = {
  maxHeight: 420, // compacted height
  overflowY: "auto",
  // Hide scrollbar while keeping scroll functionality
  "&::-webkit-scrollbar": {
    display: "none",
    width: 0,
    height: 0,
  },
  msOverflowStyle: "none", // IE and Edge
  scrollbarWidth: "none", // Firefox
} as const;
